import { organisationConstants } from '../../../_constants';

const initialState = { addManageMetricLoading: true, data: '', error: false };

export function AddManageMetric(state = initialState, action) {
    
    switch (action.type) {
        case organisationConstants.REQUEST_ADD_MANAGE_METRIC:
            return {
                addManageMetricLoading: true,
                data: '',
                error: false
            };
        case organisationConstants.RECEIVE_ADD_MANAGE_METRIC:
            return {
                addManageMetricLoading: false,
                data: action.manageMetricList,
                error: false
            };
        case organisationConstants.ADD_MANAGE_METRIC_ERROR:
            return {
                addManageMetricLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/manageMetric/addManageMetric.reducer.js